export function generateMonths() {
  return [
    { value: 1, name: "January" },
    { value: 2, name: "February" },
    { value: 3, name: "March" },
    { value: 4, name: "April" },
    { value: 5, name: "May" },
    { value: 6, name: "June" },
    { value: 7, name: "July" },
    { value: 8, name: "August" },
    { value: 9, name: "September" },
    { value: 10, name: "October" },
    { value: 11, name: "November" },
    { value: 12, name: "December" },
  ];
}

export function generateYears() {
  const currentYear = new Date().getFullYear();
  return [0,1,2,3,4,5,6].map( i => { 
    let value = currentYear - i;
    return {value};
  });
}



// WEBPACK FOOTER //
// ./src/shared-components/report/dateUtils.js